import { Component, Output, EventEmitter, Input, ContentChildren, QueryList, ElementRef, AfterContentInit } from '@angular/core';

@Component({
    selector: 'aside',
    templateUrl: './aside.component.html',
    styleUrls: ['./aside.component.scss']
})

export class AsideComponent implements AfterContentInit{

  @Input() title: string = "";
  isOpen: boolean = false;
  @Output() onClose: EventEmitter<boolean> = new EventEmitter<boolean>();
  @ContentChildren('content') grouped: QueryList<ElementRef>;

    constructor() {

  }

  ngAfterContentInit(): void {
    let ok = '';
    this.grouped.forEach((item: any) => {
      item.onClose.listen(() => close());
    });
  }

  close(): void {
    this.isOpen = false;
    this.onClose.emit(true);
  }

  open(): void {
    this.isOpen = true;
  }
}
